export default "__VITE_ASSET__D64JN$Re__"